// extracted by mini-css-extract-plugin
export default {"container":"XQ-z","darkBackground":"YQ-z","whiteBackground":"ZQ-z","headerButton":"_Q-z","calloutHeading":"aR-z","calloutSubHeading":"bR-z"};